module.exports = __webpack_public_path__ + "static/media/Kids Kicking Cancer.ae1a0558.png";